// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.business-container {
    display: flex;
    /* flex-wrap: wrap; */
    /* justify-content: space-between; */
}

.business-promo__container {
    height: 403px;
    overflow: hidden;
    position: relative;
}

.business-promo__img {
    height: 100%;
    width: 100%;
    object-fit: cover;
    object-position: center;
}

.business-promo__col-container {
    padding: 0px;
    display: flex;
    justify-content: flex-end;
    /* align-items: center; */
    background-color: var(--main-green-color);
}

.business-promo__text-container {
    width: 600px;
    /* background-color: yellow; */
    display: flex;
    /* vertical-align: middle; */
}

.business-promo__text {
    color: #fff;
    font-size: 45px;
    line-height: 60px;
    font-weight: 700;
    text-align: left;
    margin: auto 0;
    padding-left: 0px;
}

.business-promo__text-2 {
    color: #fff;
    font-size: 34px;
    line-height: 45px;
    font-weight: 700;
    text-align: left;
    margin: auto 0;
    padding-left: 0px;
    padding-right: 10px;
}

@media (max-width: 1210px) {
    .business-promo__text-container {
        width: 100%;
        padding-left: 30px;
    }
    .business-promo__text-2 {
        font-size: 28px;
        line-height: 40px;
    }
}

/* Start - Програми підтримки бізнесу */

.business-listOfPrograms__info {
    text-align: justify;
}

.business-listOfPrograms__info p {
    font-family: 'Segoe UI', 'Roboto', 'Oxygen',
    'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue',
    sans-serif !important;
    font-size: 16px;
    line-height: 18px;
    margin-bottom: 25px !important;
}

.business-listOfPrograms__info span {
    font-family: 'Segoe UI', 'Roboto', 'Oxygen', 'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue', sans-serif !important;
    font-size: 16px !important;
    line-height: 18px !important;
}
    
.business-listOfPrograms__info p ~ ul {
    margin-top: -20px;
 }

.business-listOfPrograms__info ul {
    line-height: 18px;
    list-style-type: disc;
    margin-bottom: 25px;
}

.business-listOfPrograms__info li {
    line-height: 18px;
    margin-bottom: 10px;
}

.business-listOfPrograms__info li > p {
    margin-bottom: 5px;
}

/* End - Програми підтримки бізнесу */


/* Start - Менторська програма підтримки бізнесу */

.business-mentoringProgram__container {
    width: 100%;
    padding-left: 100px;
    padding-right: 100px;
    
}

.business-mentoringProgram__text {
    text-align: justify;
}

/* End - Менторська програма підтримки бізнесу */



/* Start - Що потрібно знати */

.business-relocationRequest__text {
    text-align: justify;
}

.business-relocationRequest__points-container {
    display: flex;
    flex-direction: column;
    align-items: center;
}

.business-relocationRequest__point {
    width: 8px;
    height: 8px;
    margin: 0px 0px 10px 0px;
    background-color: var(--main-green-color);
    border-radius: 50%;
}

/* End - Що потрібно знати */

/* Start - accomodation-offers */
.business-accomodationOffers__link {
    /* color: #2bd191be; */
    color: var(--main-green-color);
    text-decoration: underline;
    font-size: 28px;
}

.business-accomodationOffers__link:hover, .business-accomodationOffers__link:active {
    cursor: pointer;
    color: #0a58ca;
}


@media (max-width: 767px) {
    .business-promo__container {
        display: none;
    }

    .business-mentoringProgram__container {
        width: 95%;
        padding-left: 60px;
        padding-right: 60px;
    }
}

@media (max-width: 575px) {
    .business-mentoringProgram__container {
        padding-left: 30px;
        padding-right: 30px;
        margin-top: 30px;
    }
}
`, "",{"version":3,"sources":["webpack://./src/styles/business.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,qBAAqB;IACrB,oCAAoC;AACxC;;AAEA;IACI,aAAa;IACb,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;IACI,YAAY;IACZ,WAAW;IACX,iBAAiB;IACjB,uBAAuB;AAC3B;;AAEA;IACI,YAAY;IACZ,aAAa;IACb,yBAAyB;IACzB,yBAAyB;IACzB,yCAAyC;AAC7C;;AAEA;IACI,YAAY;IACZ,8BAA8B;IAC9B,aAAa;IACb,4BAA4B;AAChC;;AAEA;IACI,WAAW;IACX,eAAe;IACf,iBAAiB;IACjB,gBAAgB;IAChB,gBAAgB;IAChB,cAAc;IACd,iBAAiB;AACrB;;AAEA;IACI,WAAW;IACX,eAAe;IACf,iBAAiB;IACjB,gBAAgB;IAChB,gBAAgB;IAChB,cAAc;IACd,iBAAiB;IACjB,mBAAmB;AACvB;;AAEA;IACI;QACI,WAAW;QACX,kBAAkB;IACtB;IACA;QACI,eAAe;QACf,iBAAiB;IACrB;AACJ;;AAEA,uCAAuC;;AAEvC;IACI,mBAAmB;AACvB;;AAEA;IACI;;yBAEqB;IACrB,eAAe;IACf,iBAAiB;IACjB,8BAA8B;AAClC;;AAEA;IACI,sIAAsI;IACtI,0BAA0B;IAC1B,4BAA4B;AAChC;;AAEA;IACI,iBAAiB;CACpB;;AAED;IACI,iBAAiB;IACjB,qBAAqB;IACrB,mBAAmB;AACvB;;AAEA;IACI,iBAAiB;IACjB,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;AACtB;;AAEA,qCAAqC;;;AAGrC,kDAAkD;;AAElD;IACI,WAAW;IACX,mBAAmB;IACnB,oBAAoB;;AAExB;;AAEA;IACI,mBAAmB;AACvB;;AAEA,gDAAgD;;;;AAIhD,8BAA8B;;AAE9B;IACI,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,mBAAmB;AACvB;;AAEA;IACI,UAAU;IACV,WAAW;IACX,wBAAwB;IACxB,yCAAyC;IACzC,kBAAkB;AACtB;;AAEA,4BAA4B;;AAE5B,gCAAgC;AAChC;IACI,sBAAsB;IACtB,8BAA8B;IAC9B,0BAA0B;IAC1B,eAAe;AACnB;;AAEA;IACI,eAAe;IACf,cAAc;AAClB;;;AAGA;IACI;QACI,aAAa;IACjB;;IAEA;QACI,UAAU;QACV,kBAAkB;QAClB,mBAAmB;IACvB;AACJ;;AAEA;IACI;QACI,kBAAkB;QAClB,mBAAmB;QACnB,gBAAgB;IACpB;AACJ","sourcesContent":[".business-container {\n    display: flex;\n    /* flex-wrap: wrap; */\n    /* justify-content: space-between; */\n}\n\n.business-promo__container {\n    height: 403px;\n    overflow: hidden;\n    position: relative;\n}\n\n.business-promo__img {\n    height: 100%;\n    width: 100%;\n    object-fit: cover;\n    object-position: center;\n}\n\n.business-promo__col-container {\n    padding: 0px;\n    display: flex;\n    justify-content: flex-end;\n    /* align-items: center; */\n    background-color: var(--main-green-color);\n}\n\n.business-promo__text-container {\n    width: 600px;\n    /* background-color: yellow; */\n    display: flex;\n    /* vertical-align: middle; */\n}\n\n.business-promo__text {\n    color: #fff;\n    font-size: 45px;\n    line-height: 60px;\n    font-weight: 700;\n    text-align: left;\n    margin: auto 0;\n    padding-left: 0px;\n}\n\n.business-promo__text-2 {\n    color: #fff;\n    font-size: 34px;\n    line-height: 45px;\n    font-weight: 700;\n    text-align: left;\n    margin: auto 0;\n    padding-left: 0px;\n    padding-right: 10px;\n}\n\n@media (max-width: 1210px) {\n    .business-promo__text-container {\n        width: 100%;\n        padding-left: 30px;\n    }\n    .business-promo__text-2 {\n        font-size: 28px;\n        line-height: 40px;\n    }\n}\n\n/* Start - Програми підтримки бізнесу */\n\n.business-listOfPrograms__info {\n    text-align: justify;\n}\n\n.business-listOfPrograms__info p {\n    font-family: 'Segoe UI', 'Roboto', 'Oxygen',\n    'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue',\n    sans-serif !important;\n    font-size: 16px;\n    line-height: 18px;\n    margin-bottom: 25px !important;\n}\n\n.business-listOfPrograms__info span {\n    font-family: 'Segoe UI', 'Roboto', 'Oxygen', 'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue', sans-serif !important;\n    font-size: 16px !important;\n    line-height: 18px !important;\n}\n    \n.business-listOfPrograms__info p ~ ul {\n    margin-top: -20px;\n }\n\n.business-listOfPrograms__info ul {\n    line-height: 18px;\n    list-style-type: disc;\n    margin-bottom: 25px;\n}\n\n.business-listOfPrograms__info li {\n    line-height: 18px;\n    margin-bottom: 10px;\n}\n\n.business-listOfPrograms__info li > p {\n    margin-bottom: 5px;\n}\n\n/* End - Програми підтримки бізнесу */\n\n\n/* Start - Менторська програма підтримки бізнесу */\n\n.business-mentoringProgram__container {\n    width: 100%;\n    padding-left: 100px;\n    padding-right: 100px;\n    \n}\n\n.business-mentoringProgram__text {\n    text-align: justify;\n}\n\n/* End - Менторська програма підтримки бізнесу */\n\n\n\n/* Start - Що потрібно знати */\n\n.business-relocationRequest__text {\n    text-align: justify;\n}\n\n.business-relocationRequest__points-container {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n}\n\n.business-relocationRequest__point {\n    width: 8px;\n    height: 8px;\n    margin: 0px 0px 10px 0px;\n    background-color: var(--main-green-color);\n    border-radius: 50%;\n}\n\n/* End - Що потрібно знати */\n\n/* Start - accomodation-offers */\n.business-accomodationOffers__link {\n    /* color: #2bd191be; */\n    color: var(--main-green-color);\n    text-decoration: underline;\n    font-size: 28px;\n}\n\n.business-accomodationOffers__link:hover, .business-accomodationOffers__link:active {\n    cursor: pointer;\n    color: #0a58ca;\n}\n\n\n@media (max-width: 767px) {\n    .business-promo__container {\n        display: none;\n    }\n\n    .business-mentoringProgram__container {\n        width: 95%;\n        padding-left: 60px;\n        padding-right: 60px;\n    }\n}\n\n@media (max-width: 575px) {\n    .business-mentoringProgram__container {\n        padding-left: 30px;\n        padding-right: 30px;\n        margin-top: 30px;\n    }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
